export const baseSkills = [
  { label: 'Marketing', isSelected: false, id: 3 },
  { label: 'Development', isSelected: false, id: 2 },
  { label: 'Communications', isSelected: false, id: 4 },
  { label: 'Video Production', isSelected: false, id: 5 },
  { label: 'Design', isSelected: false, id: 1 },
  { label: 'Writing', isSelected: false, id: 6 },
  { label: 'Strategy', isSelected: false, id: 7 },
  { label: 'Digital Marketing', isSelected: false, id: 8 },
  { label: 'E-Commerce', isSelected: false, id: 9 },
  { label: 'Project Managers', isSelected: false, id: null },
  { label: 'Analytics & Data', isSelected: false, id: null },

  //needs to add the commented one's to the backend.
];
